import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-order",
  "use": "icon-icon-order-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-order\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 4H7H9V16H7V6H5V4ZM5 6V8H3V6H5ZM13 4H11V16H13H15V14H17V12H15V14H13V4Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol